RivalIQ.apps.Discovery.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    data.followerCountBands = _.map([
        {
            low: 1000
        },
        {
            low: 1000,
            high: 10000
        },
        {
            low: 10000,
            high: 50000
        },
        {
            low: 50000,
            high: 200000
        },
        {
            low: 200000
        }
    ], function (band) {
        band.id = [band.low, band.high].join(' - ');
        return band;
    });

});
